<template>
  <div class="page" v-wechat-title="$route.meta.title">


    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>


</template>

<script>

  import P400 from '../../components/P400'
  import {activate} from "@/service/getData";
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        specialId: '', //线路id
        userInfo: {}, //用户信息
        latlng: {lat:'',lng:''}, //经纬度信息
        loadText: "数据加载中",
        loadEnd: false, //数据加载结束则赋值为true

        TimeStamp: new Date().getTime(),  //获取当前时间
        shopid:'',
        appKey: '',
        appKeyA: '',
        P400: 0, //系统维护中
      }
    },
    computed: {

    },
    created(){
      let self = this;

      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.userInfo1 = getStore("userInfo1",1);

      this.shopid = this.$route.query.shopid || "";
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey);
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }

      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }

      this.activateFun();
    },
    methods: {

      //初始化数据
      async activateFun(){
        let res = await activate({
          openid: this.userInfo.openid
        });
        console.log(res.data)
        if(res.errcode == "00000"){
          if(this.shopid){
            this.$router.push({
              path: `/view-detail?${'shopid='+ this.shopid +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
            });
          }else {
            this.$router.push({
              path: `/?${'siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
            });
          }

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }

      },



    },
    watch:  {

    },
    components: {
      P400
    },
  }

</script>

<style scoped>
  @import "../../style/view.css";

  .page{ background-color: #f9f9f9; min-height: 100vh; padding-bottom: .2rem; }

  /* banner */
  .banner{ position: relative;height:15%;border-radius:.07rem; z-index: 2; }
  .swiper-box{ border-radius: 0;}

  /* 景区列表 */
  .conference-list{ background-color: #f9f9f9;}
  .conference-number{ position: relative; z-index: 1; display: inline-block; width: 1.1rem; height: .6rem; margin-top: .27rem; padding: 0 .388rem; font: .24rem/.6rem "Microsoft YaHei"; color: #000; border-radius: .6rem; background-color: #fff; box-shadow: 0 2px 5px #e3e3e3; -webkit-box-shadow: 0 3px 5px #ddd; }
  .conference-number b{ display: inline-block; width: .12rem; height: .12rem; margin-right: .15rem; background-color: #faaf39; border-radius: .12rem;vertical-align: middle; }
  .conference-number:before{ position: absolute; width: .07rem; height: .31rem; left: .41rem; top: -.31rem; background-color: #ffbb17; content: ''; }

  .conference-item-parent{ margin-top: .27rem; z-index: 2; }
  .conference-item-parent:before{ position: absolute; width: .07rem; height: .27rem; left: .41rem; top: -.27rem; background-color: #ffbb17; content: ''; }
  .conference-item{ position: relative; margin-top: 0; box-shadow: 0 2px 5px #e3e3e3; -webkit-box-shadow: 0 3px 5px #ddd;  }
  .conference-item-img,.conference-item-img img{ border-radius: .15rem .15rem 0 0;}
  .conference-item-hover-text{ left: .15rem; top: 0; }
  .conference-item-title{ padding-left: .1rem;}
  .conference-item-info{ overflow: hidden; }
  .conference-item-info-label{ margin-left: 0; margin-right: .1rem;}




</style>



// WEBPACK FOOTER //
// src/page/home/home-zj.vue